module.exports = __webpack_public_path__ + "static/media/组 4462@2x.3a581d02.png";